module.exports = __webpack_public_path__ + "img/ev_local.57e35587.png";